module.exports = __webpack_public_path__ + "static/media/HangedMan.d15243b2.png";